import { useIntl } from 'react-intl'

import BackButton from '@components/BackButton'

// Top-of-card "Back to sign in" for the error/not-found/verification screens —
// the shared ghost BackButton pointing at /login.
const BackToLogin = () => {
  const intl = useIntl()
  return (
    <BackButton to='/login' dataTestId='back-to-login'>
      {intl.formatMessage({ id: 'recovery.backToLogin' })}
    </BackButton>
  )
}

export default BackToLogin
